import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import BreadcrumbBack from '../../../../components/breadcrumb/BreadcrumbBack';
import CustomButton from '../../../../components/button/CustomButton';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getGumletCollections,
  getGumletCollectionsPlaylist,
  getGumletCollectionsPlaylistVideo,
  getGumletToken,
  importGumletPlaylistDir,
  importGumletPlaylistVideos,
} from '../../../../service/admin/adminGumlet.service';
import { CiWarning } from 'react-icons/ci';
import DataNotFound from '../../../../components/errors/DataNotFound';
import { FaAngleLeft, FaAngleRight, FaFolder, FaPlay } from 'react-icons/fa';
import { truncateString } from '../../../../helpers/helpers';
import Models from '../../../../components/models/Models';
import YoutubePlayer2 from '../../../../components/player/VimeoPlayer2';
import Loaders from '../../../../components/loaders/Loaders';
import moment from 'moment';
import { current } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { SubmitHandler, useForm } from 'react-hook-form';
import { getVideosActiveModule, getVideosActiveSubModuleByModule } from '../../../../service/admin/adminVideoes.service';
import MultiSearchableSelect from '../../../../components/form/MultiSearchableSelect';
import FormButton from '../../../../components/button/FormButton';
import YoutubePlayer from '../../../../components/player/YoutubePlayer';
import GumletPlayers from '../../../../components/player/GumletPlayers';

export default function GumletVideo() {
  const PAGE_LIMIT = 10;
  const [tableLoad,setTableLoad] = useState(false)
  const [pageLoad, setPageLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState<any>();
  const [collection, setCollection] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [open, setOpen] = useState(false);
  const [currentImportDir, setCurrentImportDir] = useState<any>(null)
  const [playlist, setPlaylist] = useState([]);
   const [show, setShow] = useState<any>('module');
    const [moduleData, setModuleData] = useState<any>([]);
      const [moduleSubData, setModuleSubData] = useState<any>([]);
      const [open1, setOpen1] = useState<any>(false);
      const { handleSubmit, control } = useForm<any>();
  const [video, setVideo] = useState([]);
  const [pagination, setPagination] = useState<any>({
            total:0,
            offset:0,
  });
  const navigate = useNavigate();
  
  const [currentVideo, setCurrentVideo] = useState<any>(null);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [currentTab, setCurrentTab] = useState(0);
  const [breadcrumb, setBreadcrumb] = useState([{ title: 'Root', path: '/admin/videos/gumlet' }]);
  const fetchToken = async () => {
    let get: any = await getGumletToken();
    if (get?.status === 'success') {
      setToken(get?.message);
    } else {
      setCurrentTab(-1);
    }
  };
  const fetchCollection = async () => {
    if (token) {
      setTableLoad(true)
      let get: any = await getGumletCollections();
      if (get?.status === 'success') {
        setCollection(get?.message.data);
      }
      setTableLoad(false);
    }
  };
  const fetchPlaylist = async (id: string) => {
    if (id) {
      setTableLoad(true)
      let get: any = await getGumletCollectionsPlaylist(id);
      if (get?.status === 'success') {
        setTableLoad(false)
        setPlaylist(get?.message);
      }else{
        navigate('/admin/videos/gumlet')
        fetchToken()
        window.location.reload()
      }
      setTableLoad(false)
    }
  };
  const fetchVideos = async (collectionId: string, id: any, page?:number) => {
    if (id) {
      setTableLoad(true)
        let pag = page || 1
      let get: any = await getGumletCollectionsPlaylistVideo(collectionId, id, pag);
      if (get?.status === 'success') {
        setVideo(get?.message.data);
        setPagination({
           total:get?.message?.pagination.total_asset_count,
           offset:get?.message?.pagination.current_offset
        })
        setTableLoad(false)
      }else{
        navigate('/admin/videos/gumlet')
        window.location.reload()
      }
      setTableLoad(false)
    }
  };
  useEffect(() => {
    fetchToken();
  }, []);

  const handleCollections = async()=>{
    setCurrentTab(0);
    fetchCollection();
  }
  const handlePlaylist = async (id: any,name?:any) => {
    setCurrentTab(1);
    setBreadcrumb((prev:any)=>{
    return [...prev, { title: name, path: `/admin/videos/gumlet?video=playlist` }];
    })
    if (collection.length !== 0) {
      let fil: any = collection.filter((item: any) => item.id === id);
      let currentData = {
        id: fil[0].id,
        name: fil[0].name,
      };
      localStorage.setItem(
        'currectGumletCollection',
        JSON.stringify(currentData)
      );
    }
    // navigate('/admin/videos/gumlet?video=playlist');
    fetchPlaylist(id);
  };

  const handleVideos = async (id: any,page?:number,name?:any) => {
    setCurrentImportDir(null)
    let pag = page || 1
    setCurrentTab(2);
    console.log(name)
    setBreadcrumb((prev:any)=>{
      return [...prev, { title: name, path: `/admin/videos/gumlet?video=video` }];
      })
    if (playlist.length !== 0) {
      let fil: any = playlist.filter((item: any) => item.id === id);
      let currentData = {
        id: fil[0].id,
        name: fil[0].name,
      };
      localStorage.setItem(
        'currectGumletPlaylist',
        JSON.stringify(currentData)
      );
    }
    // navigate('/admin/videos/gumlet?video=video');
    fetchVideos(
      JSON.parse(localStorage.getItem('currectGumletCollection')!).id,
      id,
      pag
    );
  };
  const handlePlay = (item: any) => {
    console.log(item)
    setOpen(!open);
    setCurrentVideo(item);
  };
  useEffect(()=>{
    setBreadcrumb([
      {
        title: 'Root',
        path: '/admin/videos/gumlet',
      }
    ])
    setCurrentTab(0);
    fetchCollection();
  },[token])
 const handleNext = () => {
  handleRemoveSelectedRow()
  if (pagination.offset + PAGE_LIMIT < pagination.total) {
    setPagination({
      total: pagination.total,
      offset: pagination.offset + PAGE_LIMIT,
    })
    handleVideos(JSON.parse(localStorage.getItem('currectGumletPlaylist')!).id,pagination.offset + PAGE_LIMIT,JSON.parse(localStorage.getItem('currectGumletPlaylist')!).name)

  }
};

const handlePrev = () => {
  handleRemoveSelectedRow()
  if (pagination.offset > 0) {
    setPagination({
      total: pagination.total,
      offset: Math.max(0, pagination.offset - PAGE_LIMIT),
    })
    handleVideos(JSON.parse(localStorage.getItem('currectGumletPlaylist')!).id,Math.max(0, pagination.offset - PAGE_LIMIT),JSON.parse(localStorage.getItem('currectGumletPlaylist')!).name)
  }
};
const handleAllSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
  const isChecked = event.target.checked;
  setIsAllChecked(isChecked); // Update state first

  const checkboxes = document.querySelectorAll(".tablecheckbox") as NodeListOf<HTMLInputElement>;
  checkboxes.forEach((checkbox) => (checkbox.checked = isChecked)); // Apply the checked state
};
const handleRowSelect = (event: React.ChangeEvent<HTMLInputElement>)=>{
  const isChecked = event.target.checked;
  setIsAllChecked(isChecked);
}
const handleRemoveSelectedRow = ()=>{
  const isChecked = false;
  setIsAllChecked(isChecked);
  const checkboxes = document.querySelectorAll(".tablecheckbox") as NodeListOf<HTMLInputElement>;
  checkboxes.forEach((checkbox) => (checkbox.checked = isChecked));
}
const handleAllCheckBoxedItems = async()=>{
  setOpen1(!open1)
}


const onSubmit: SubmitHandler<any> = async (data: any) => {
      setLoading(true);
    let datam: any = [];
    if (data?.fk_submodule_id?.length > 0) {
      data.fk_submodule_id.map((item: any) => {
        let find: any = moduleSubData.find((i: any) => i.value === item);
        datam.push({
          m: find.module,
          s: find.value,
        });
      });
    }
    
    if(datam.length !== 0) {
      if(currentImportDir !== null){
        let collect:any = JSON.parse(localStorage.getItem('currectGumletCollection')!).id;
        let cr:any = await importGumletPlaylistDir(collect,currentImportDir,datam);
        if(cr?.status === "success"){
          setLoading(false);
          
           navigate("/admin/videos")
           return  toast.success("Playlist created successfully");
        }
      }else{
    const checkedBoxes = document.querySelectorAll(".tablecheckbox:checked");
  const values = Array.from(checkedBoxes).map((checkbox) => (checkbox as HTMLInputElement).getAttribute("data-set"));
  if(values.length !== 0){
    let newData:any= [];
     values.map((item:any)=>{
      let parseData = JSON.parse(item);
      newData.push({
        name:parseData.name,
        length:parseData.duration,
        slug:parseData.id,
        description:"gumlet",
        thumbnail:parseData.thumbnail_url.length === 1 ? parseData.thumbnail_url[0] : parseData.thumbnail_url,
        url:parseData.url,
        status:true,
        watchtime:0,
      })
    })
    if(newData.length === 0){
      setLoading(false);
      return toast.error("please select video ");
    }else{
      let cr:any = await importGumletPlaylistVideos(newData,datam);
      if(cr?.status === "success"){
        setLoading(false);
        navigate("/admin/videos")
           toast.success("Playlist created successfully");
          
      }
    }
  }
  }
    }
    // restriction
    setLoading(false);
  };
const fetchModules = async () => {
    const get: any = await getVideosActiveModule();
    if (get?.status === 'success') {
      let data: any = [];
      get.message.map((item: any) => {
        data.push({ value: item.id, label: item.name });
      });
      setModuleData(data);
      //   fetchSubModules();
    }
  };
  const fetchSubModules = async (id: string) => {
    const get: any = await getVideosActiveSubModuleByModule(id);
    if (get?.status === 'success') {
      let data: any = [];
      get.message.map((item: any) => {
        data.push({
          value: item.id,
          label: item.name,
          module: item.fk_videoModule_id,
        });
      });
      let newarray = [...moduleSubData, ...data];
      setModuleSubData(newarray);
    }
  };
  const handlefetch = async (data: any) => {
    if (data?.selected.length > 0) {
      if (data?.removed === undefined) {
        fetchSubModules(data?.selected[data?.selected.length - 1]);
      } else {
        let updated = moduleSubData.filter(
          (item: any) => item.module !== data?.removed
        );
        setModuleSubData(updated);
      }
    } else {
      setModuleSubData([]);
    }
  };
  useEffect(() => {
    fetchModules();
  }, []);
  return (
    <>
      <Helmet>
        <title>{`Gumlet Videos   | ${window.location.hostname}`}</title>
      </Helmet>
      {pageLoad ? (
        <Loaders type="spinner" />
      ) : (
        <>
          <BreadcrumbBack title="Manage Gumlet Videos">
            <CustomButton
              title="Manage Gumlet Account"
              onClick={() => navigate('/admin/videos/gumlet/account')}
            />
          </BreadcrumbBack>
          <div className='my-3 bg-gray-300 p-1 rounded-xl flex-col md:flex-row justify-between  px-4 flex md:justify-between items-center'>
           <div>
            {
              currentTab === 0 && <p className='text-gray-900'>Collections</p>
            }
            {
              currentTab === 1 && <div className='flex gap-2'>
                <p onClick={handleCollections} className='text-gray-600 hover:cursor-pointer'>Collections</p>
                <p className='text-gray-700'>/</p>
                <p className='text-gray-900 '>Playlists</p>
              </div>
            }
            {
              currentTab === 2 && <div className='flex gap-2'>
                <p onClick={handleCollections} className='text-gray-600 hover:cursor-pointer'>Collections</p>
                <p className='text-gray-700'>/</p>
                <p  onClick={(()=>handlePlaylist( JSON.parse(localStorage.getItem('currectGumletCollection')!).id))} className='text-gray-600 hover:cursor-pointer '>Playlists</p>
                <p className='text-gray-700'>/</p>
                <p className='text-gray-900 '>Videos</p>
              </div>
            }
           </div>
           <p className='text-lg'><b>Current Account : </b> {token?.name} </p>
          </div>
          {token?.token === false && (
            <div className=" min-h-[50vh] my-2 w-full flex items-center justify-center flex-col ">
              <CiWarning className=" text-[4rem] text-yellow-700" />
              <p className="mb-10 text-2xl text-red-600 font-bold">
                No Account Selected
              </p>
              <CustomButton
                onClick={() => navigate('/admin/videos/gumlet/account')}
                title="Select Account"
              />
            </div>
          )}

            {currentTab === 0 ? 
             
                collection.length !== 0 ? (
                    <div className="grid my-4 grid-cols-2 lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-2 gap-4">
                    {collection.map((item: any,index:number) => (
                        <div
                        key={index}
                        onClick={() => handlePlaylist(item.id,item?.name)}
                        className=" border hover:cursor-pointer  rounded-lg p-2 border-gray-300 flex flex-col items-center justify-center"
                        >
                        <FaFolder className={` text-[5rem] text-[#fbbf24]`} />
                        <p data-tooltip={item.name} data-tooltip-location="bottom">
                            {truncateString(item.name, 15)}
                        </p>
                        </div>
                    ))}
                    </div>
                )
                :
                <Loaders type="spinner" />
                :
                currentTab === 1 ?
                playlist.length !== 0 && (
                    <div className="grid my-4 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 sm:grid-cols-2 gap-4">
                    {playlist.map((item: any,index:number) => (
                        <div
                        key={index}
                        
                        className=" border   rounded-lg p-2 border-gray-300 flex flex-col items-center justify-center"
                        >
                        <FaFolder className={` text-[8rem] text-[#fbbf24]`} />
                        <p data-tooltip={item.name} data-tooltip-location="bottom" className='text-lg mb-2 font-semibold'>
                            {truncateString(item.name, 30)}
                        </p>
                        <div className='flex justify-between gap-2 w-full'>
                          <button onClick={(()=>{setCurrentImportDir(item.id);setOpen1(!open1)})}  className='p-3 bg-gray-400 text-white rounded-lg  w-full'>Import</button>
                          <button onClick={() => handleVideos(item.id,1,item?.name)} className='p-3 bg-gray-600 text-white rounded-lg  w-full'>Videos</button>
                        </div>
                        </div>
                    ))}
                    </div>
                )
                :
                currentTab === 2 ?
                video.length !== 0 && (
                    <div className=" my-4">
                      {
                        isAllChecked &&
                        <div className='flex justify-end items-center'>
                        <button disabled={loading} onClick={handleAllCheckBoxedItems} className='px-4  py-2 mb-1 rounded-xl mr-2 text-white bg-purple-800'>
                          {
                            loading ?
                            'importing...' : 
                            'Import Videos'
                          }
                        </button>
                        </div>
                      }
                      
                        <table className=' border-collapse w-full'>
                            <thead>
                            <th className=' p-2 border-gray-300 border-b border-t border-l  w-[5%] text-left font-semibold'>S.no</th>

                                <th  className=' p-2 border-gray-300 border-b border-t  w-[10%]'><input onChange={handleAllSelect} className='w-[20px] h-[20px]' type="checkbox" /></th>
                                <th className=' p-2 border-gray-300 border-b border-t  w-[45%] text-left font-semibold'>Video</th>
                                <th className=' p-2 border-gray-300 border-b border-t  w-[10%] text-left font-semibold'>Duration</th>
                                <th className=' p-2 border-gray-300 border-b border-t  w-[10%] text-left font-semibold'>Upload On</th>
                                <th className=' p-2 border-gray-300 border-b border-t border-r text-center  w-[20%] font-semibold'>Action</th>
                            </thead>
                            <tbody>
                            {video.map((item: any,index:number) => (
                                <tr key={index} >
                                    <td className='border-b border-t border-l  border-gray-300 text-left p-2'>{pagination.offset+1+index}.</td>

                                    <td className='border-b border-t  border-gray-300 text-center p-2'>
                                      <input data-set={JSON.stringify(item)} onChange={handleRowSelect}  className='w-[20px] h-[20px] tablecheckbox' type="checkbox" /></td>
                                    <td className='border-b border-t  border-gray-300 p-2'>
                                    <div className="flex flex-col md:flex-row gap-4 items-center ">
                                        <img
                                        className="w-[100px] rounded-2xl"
                                        src={item.thumbnail_url.length === 1? item.thumbnail_url[0] : item.thumbnail_url}
                                        alt="img"
                                        />
                                        <p data-tooltip={item.name} data-tooltip-location="bottom">
                                        {truncateString(item?.name, 25)}
                                        </p>
                                    </div>
                                    </td>
                                    <td className='border-b border-t  border-gray-300 p-2'>
                                    { moment.utc(moment.duration(item.duration, 'seconds').asMilliseconds()).format('HH:mm:ss')}
                                    </td>
                                    <td className='border-b border-t border-gray-300 p-2'>
                                        { moment(item.created_at).fromNow()}
                                    </td>
                                    <td className='border-b border-t  border-r border-gray-300 p-2'>
                                    <div className="flex gap-4 items-center justify-center">
                                        <button
                                        onClick={() => handlePlay(item)}
                                        data-tooltip={'play'}
                                        data-tooltip-location="bottom"
                                        >
                                        <FaPlay className="text-purple-700 text-2xl hover:cursor-pointer " />
                                        </button>
                                    </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <div className='flex justify-center my-4 items-center'>
                            <div className='flex gap-3 justify-center items-center'>
                            <button
          onClick={handlePrev}
          disabled={pagination.offset === 0}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Previous
        </button>

        <button
          onClick={handleNext}
          disabled={pagination.offset  + PAGE_LIMIT >= pagination.total}
          className="px-4 py-2 bg-blue-500 text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next
        </button>
                            </div>
                        </div>
                    </div>
                  )
                :
                <DataNotFound title={"No data found"} />
            }
                
        </>
      )}
      <Models name="Video" isOpen={open} isClose={setOpen}>
        {/* <GumletPlayers id={currentVideo?.id}/> */}
        {/* <YoutubePlayer url={currentVideo?.url} /> */}
        <YoutubePlayer2 url={currentVideo?.url} watchTime={0} role="common" type={'vimoe'} />
      </Models>
      <Models name="Import videos" isOpen={open1} isClose={setOpen1}>
      <>
      <form onSubmit={handleSubmit(onSubmit)} className="mb-5">
        {/* restriction */}
        {show === 'module' ? (
          <>
            <MultiSearchableSelect
              name="fk_module_id"
              control={control}
              options={moduleData}
              onFetch={handlefetch}
              label="Select module"
            />
            <MultiSearchableSelect
              name="fk_submodule_id"
              control={control}
              options={moduleSubData}
              label="Select sub module"
            />
           
          </>
        ) : null}
        <div className="mt-10">
          <FormButton loading={loading} title={'submit'} />
        </div>
      </form>
    </>
      </Models>
    </>
  );
}
